import { showConfirmDialog } from '../../dialogs';

export default function paintListCreatedDialog(newPaintlist) {
    return showConfirmDialog({
        title: 'Nieuwe lakbon',
        content:
            'Er werd een nieuwe lakbon aangemaakt: ' +
            newPaintlist.id +
            '. Productiedatum is ' +
            newPaintlist.deadline +
            '.',
        closeOnOk: true,
        closeOnCancel: true,
        confirmButton: 'Ga naar lakbon',
        cancelButton: 'Blijf op pagina',
    });
}
